<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
  </button>
</div>

<div class="modal-body p-3">
  @if (body) {
    <div [innerHTML]="body"></div>
  }
  @if (buttonText) {
    <button class="btn btn-primary mt-2" (click)="gotoLink()">{{buttonText}}</button>
  }
  <ng-template appModalContent></ng-template>
</div>
<div class="modal-footer justify-content-center">
  @if (footerText) {
    <div class="col-12">
      <p>{{footerText}}</p>
    </div>
  }
  <div class="d-flex col-md-12 p-0 justify-content-between w-100">
    @if (isConfirm) {
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel click')">{{cancelText
        |
      translate}}</button>
      <button class="btn btn-success " (click)="confirm()">{{confirmText | translate}}</button>
    }
    @if (!isConfirm) {
      <button class="btn btn-dark " (click)="modal.dismiss('cancel click')">{{'CLOSE' | translate}}</button>
    }
  </div>
</div>
